//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('custactDeadLines', {
//        templateUrl: 'views/components/views/custactDeadLines/custactDeadLines.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'custactDeadLinesService', 'ttGridFactory', 'layoutService', function ($stateParams, stateService, custactDeadLinesService, ttGridFactory, layoutService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;
            
//            vm.model = {
//                tabletSize: layoutService.getMediaQueries().tablet,
//                gridReady: false,
//                setting: {},
//                itemsListDeadLines: []
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_custactdeadlines.grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'custactdeadline_new',
//                    text: 'custactdeadline_new',
//                    func: () => {
//                        stateService.go('custactedit', {
//                            custact_no: '0',
//                            filterfield: argType,
//                            filtervalue: argValue
//                        });
//                    },
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await custactDeadLinesService.getSetting())[0];
//            }

//            async function loadDeadLines() {
//                vm.model.itemsListDeadLines = await custactDeadLinesService.listDeadLines();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3343,
//                    parameters: {}
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'custactedit':
//                        go({
//                            custact_no: '0',
//                            filterfield: argType,
//                            filtervalue: argValue
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//                loadDeadLines();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
